import React from "react";
import { FadeLoader } from "react-spinners";
interface ILoaderProps {
  loading?: boolean;
  color?: string;
  height?: number;
  width?: number;
  css?: React.CSSProperties;
  speedMultiplier?: number;
}
function Loader(props: ILoaderProps) {
  const { loading, color = "currentColor", height = 15, width = 4, css, speedMultiplier } = props;

  return (
    <div className="grid place-items-center h-screen text-primary-sapphireBlue-900">
      <FadeLoader
        loading={loading}
        color={color}
        height={height}
        width={width}
        cssOverride={css}
        speedMultiplier={speedMultiplier}
      />
    </div>
  );
}

// memoization
export default React.memo(Loader);
